import CustomInfoRequests from './CustomInfoRequests'
export default CustomInfoRequests
